var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUpdate = function SvgUpdate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "update_svg__a",
    x1: 32,
    x2: 32,
    y1: 3.25,
    y2: 61.803,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#update_svg__a)",
    d: "M32 43c6.065 0 11-4.935 11-11s-4.935-11-11-11-11 4.935-11 11 4.935 11 11 11zm0-20c4.963 0 9 4.037 9 9s-4.037 9-9 9-9-4.037-9-9 4.037-9 9-9z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "update_svg__b",
    x1: 22.5,
    x2: 22.5,
    y1: 3.25,
    y2: 61.803,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#update_svg__b)",
    d: "M11.811 37.719A6.009 6.009 0 0 0 16 32a6.008 6.008 0 0 0-4.192-5.72C14.261 17.56 21.939 11.464 31 11.042v3.001c0 .702.367 1.333.983 1.688a2.006 2.006 0 0 0 2.013-.003l5.548-3.223a2.88 2.88 0 0 0-.001-5.009l-5.547-3.223a2.011 2.011 0 0 0-2.013-.004A1.932 1.932 0 0 0 31 5.957v3.085c-10.06.428-18.581 7.24-21.19 16.968C6.589 26.111 4 28.756 4 32c0 3.245 2.591 5.89 5.812 5.99a22.964 22.964 0 0 0 8.958 12.825l1.152-1.635a20.957 20.957 0 0 1-8.111-11.461zM38.538 9.225c.417.242.462.623.462.775s-.045.533-.461.775L33 13.985l-.008-7.983 5.546 3.223zM6 32c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4-4-1.794-4-4z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "update_svg__c",
    x1: 41.5,
    x2: 41.5,
    y1: 3.25,
    y2: 61.803,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#update_svg__c)",
    d: "M60 32c0-3.245-2.591-5.89-5.812-5.99a22.964 22.964 0 0 0-8.958-12.825l-1.152 1.635a20.964 20.964 0 0 1 8.111 11.461A6.009 6.009 0 0 0 48 32a6.01 6.01 0 0 0 4.193 5.721C49.74 46.44 42.061 52.536 33 52.958v-3.001c0-.702-.367-1.333-.983-1.688a2.009 2.009 0 0 0-2.013.004l-5.548 3.223C23.545 52.026 23 52.962 23 54s.545 1.974 1.457 2.504l5.547 3.223c.311.182.66.271 1.01.271.347 0 .693-.089 1.003-.268.616-.354.983-.985.983-1.687v-3.085c10.059-.428 18.582-7.24 21.191-16.967C57.411 37.888 60 35.244 60 32zM31 57.993l-5.538-3.218C25.045 54.533 25 54.152 25 54s.045-.533.461-.775L31 49.957v8.036zM54 36c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "update_svg__d",
    x1: 32,
    x2: 32,
    y1: 27.5,
    y2: 36.538,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#update_svg__d)",
    d: "M32 28a4 4 0 1 0 0 8 4 4 0 1 0 0-8Z"
  })));
};
export default SvgUpdate;